import { PlanTypeCardKind } from '@ebalance/proto/bffuser/v1/submission_management_model_pb'

/**
 * UNSPECIFIED を除いた実カード種別。BFF は `cards` を PlanTypeCardKind の enum
 * 順で返す契約 (proto `SubmissionDashboardArea.cards` の doc comment) のため、
 * frontend は並び替えを行わず、防御的に UNSPECIFIED だけを落として使う
 * (review 指摘: 並び順の正を backend の契約に一本化し、frontend 側の
 * 再ソートを廃止)。
 */
export type KnownPlanTypeCardKind = Exclude<
  PlanTypeCardKind,
  PlanTypeCardKind.UNSPECIFIED
>

export function isKnownPlanTypeCardKind(
  kind: PlanTypeCardKind,
): kind is KnownPlanTypeCardKind {
  return kind !== PlanTypeCardKind.UNSPECIFIED
}

/**
 * カードヘッダーの i18n key。
 * UNSPECIFIED を型で排除しているため、値は必ず `string` (undefined を返す
 * 到達不能分岐を作らない)。
 */
export const PLAN_TYPE_CARD_TITLE_I18N_KEY: Record<
  KnownPlanTypeCardKind,
  string
> = {
  [PlanTypeCardKind.DEMAND_PROCUREMENT]:
    'page:submissionManagement.card.demandProcurement',
  [PlanTypeCardKind.DEMAND_PROCUREMENT_SELF_WHEELING]:
    'page:submissionManagement.card.demandProcurementSelfWheeling',
  [PlanTypeCardKind.DEMAND_PROCUREMENT_BATTERY]:
    'page:submissionManagement.card.demandProcurementBattery',
}

/** 計画タイプカードの列 (AC-PSM-007)。左列 = 需要調達系、右列 = 発電販売系 + 分割供給。 */
export type PlanTypeCardColumn = 'left' | 'right'

/**
 * カード種別 → 列。右列の種別 (発電販売計画 / FIT) は発電販売計画の実提出リリース時に
 * proto へ足す (map #8431 Out of scope)。`Record` なので、その時にここで列を決めない
 * と型検査で落ちる。
 */
export const PLAN_TYPE_CARD_COLUMN: Record<
  KnownPlanTypeCardKind,
  PlanTypeCardColumn
> = {
  [PlanTypeCardKind.DEMAND_PROCUREMENT]: 'left',
  [PlanTypeCardKind.DEMAND_PROCUREMENT_SELF_WHEELING]: 'left',
  [PlanTypeCardKind.DEMAND_PROCUREMENT_BATTERY]: 'left',
}
